import { useEffect, useRef, useState } from 'react';
import React from 'react';

import css from './PreviewWrapper.module.css';

export default function PreviewWrapper({ children, title = 'Preview' }) {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const wrapperRef = useRef(null);

  const toggleFullscreen = async () => {
    if (!wrapperRef.current) return;

    try {
      if (!document.fullscreenElement) {
        await wrapperRef.current.requestFullscreen();
      } else {
        await document.exitFullscreen();
      }
    } catch (err) {
      console.error('Fullscreen failed:', err);
    }
  };

  // Keep state in sync (ESC, browser UI, etc.)
  useEffect(() => {
    const handleChange = () => {
      setIsFullscreen(!!document.fullscreenElement);
    };

    document.addEventListener('fullscreenchange', handleChange);
    return () => {
      document.removeEventListener('fullscreenchange', handleChange);
    };
  }, []);

  return (
    <div ref={wrapperRef} className={`${css.wrapper} ${isFullscreen ? css.fullscreen : ''}`}>
      <div className={css.header}>
        <h3 className={css.title}>{title}</h3>
        <div className={css.controls}>
          <button
            className={css.button}
            onClick={toggleFullscreen}
            aria-label={isFullscreen ? 'Izađi iz punog ekrana' : 'Puni ekran'}
          >
            {isFullscreen ? '✕' : '⤢'}
          </button>
        </div>
      </div>

      <div className={css.content}>{children}</div>
    </div>
  );
}
